export default __webpack_public_path__ + "static/media/16_pencil 2.5c8ad52c.gif";